import { render, staticRenderFns } from "./table-pagination.vue?vue&type=template&id=5def342a"
import script from "./table-pagination.vue?vue&type=script&lang=ts"
export * from "./table-pagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5def342a')) {
      api.createRecord('5def342a', component.options)
    } else {
      api.reload('5def342a', component.options)
    }
    module.hot.accept("./table-pagination.vue?vue&type=template&id=5def342a", function () {
      api.rerender('5def342a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/table-pagination.vue"
export default component.exports